var map = {
	"./404.svg": "a14a",
	"./add.svg": "c2a3",
	"./correct.svg": "5b4a",
	"./edit.svg": "aa46",
	"./join.svg": "af50",
	"./location.svg": "1c50",
	"./test_add.svg": "94d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";